const faqItems = document.querySelectorAll('.faq-item');

document.querySelectorAll('.collection-bottom-des p').forEach(paragraph => {
  if (paragraph.textContent.trim()) {
    paragraph.setAttribute('tabindex', '0');
  }
});

document.querySelectorAll('.faq-content').forEach(content => {
  if (content.textContent.trim()) {
    content.setAttribute('tabindex', '0');
  }
});

  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');

    question.addEventListener('click', () => {

      // Toggle current
      item.classList.toggle('active');
      const answer = item.querySelector('.faq-answer');

      if (item.classList.contains('active')) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
      } else {
        answer.style.maxHeight = null;
      }
    });
  });